export default __webpack_public_path__ + "static/media/map-pin-project.dd2d205c.svg";